export const GLASS_APPEARANCE_MODES = ['sunrise', 'mist', 'sage', 'sand', 'clouds', 'dark'] as const;

export type GlassAppearanceMode = (typeof GLASS_APPEARANCE_MODES)[number];

export type AppearanceMode = 'light' | GlassAppearanceMode;

export const APPEARANCE_MODES: ReadonlyArray<{
  id: AppearanceMode;
  label: string;
  hint: string;
  preview: readonly [string, string, string] | null;
}> = [
  { id: 'light', label: 'Light', hint: 'Clean white background', preview: null },
  { id: 'sunrise', label: 'Sunrise', hint: 'Warm paper tone with soft glass panels', preview: ['#f3f0eb', '#f9f7f4', '#f4f0ea'] },
  { id: 'mist', label: 'Mist', hint: 'Cool blue-grey with soft glass panels', preview: ['#e8edf2', '#f4f7fa', '#eef2f6'] },
  { id: 'sage', label: 'Sage', hint: 'Soft green-grey with soft glass panels', preview: ['#e8ede6', '#f2f6f0', '#e9efe5'] },
  { id: 'sand', label: 'Sand', hint: 'Golden neutral with soft glass panels', preview: ['#f0ebe3', '#f8f4ed', '#efe8de'] },
  { id: 'clouds', label: 'Clouds', hint: 'Soft lavender-grey with soft glass panels', preview: ['#ebe9ef', '#f5f4f7', '#eeecf2'] },
  { id: 'dark', label: 'Dark', hint: 'Balanced charcoal with soft glass panels', preview: ['#121214', '#141416', '#18181b'] },
];

const VALID_MODES = new Set<string>(APPEARANCE_MODES.map((m) => m.id));

export function isValidAppearanceMode(value: string | null | undefined): value is AppearanceMode {
  return value != null && VALID_MODES.has(value);
}

export function isGlassAppearance(mode: AppearanceMode): boolean {
  return mode !== 'light';
}
